import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class PartyOfficialAuthService {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {

    if (localStorage.getItem('userType') === '3' && localStorage.getItem('roleId') === '4') {
      return true;
    } else if (localStorage.getItem('userType') === '2' &&
     (localStorage.getItem('roleId') === '7' || localStorage.getItem('roleId') === '8' || localStorage.getItem('roleId') === '11' || localStorage.getItem('roleId') === '12')) {
      return true;
    } else {
      this.router.navigate(['/userview/dashboard']);
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/AUTHGAURD/party-official-auth.service.ts